var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt gantt-column"
  }, [_c('div', {
    staticClass: "gantt-row"
  }, [_c('gantt-legend', {
    ref: "legend",
    attrs: {
      "rows": _vm.tasks,
      "legendHelp": _vm.legendHelp
    },
    on: {
      "task-click": _vm.handleTaskClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gantt-column",
    style: ({
      width: _vm.cellsCount * 24
    }),
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [_c('gantt-header', {
    attrs: {
      "rows": _vm.header
    },
    on: {
      "header-click": _vm.handleHeaderClick
    }
  }), _vm._v(" "), _c('gantt-body', {
    attrs: {
      "tasks": _vm.body
    }
  })], 1)], 1), _vm._v(" "), _c('gantt-footer', {
    attrs: {
      "scales": _vm.scales,
      "selected": _vm.selectedScaleIdx,
      "startDate": _vm.min,
      "endDate": _vm.max,
      "step": _vm.msInCell,
      "period": _vm.viewportStart
    },
    on: {
      "scale-change": _vm.handleScaleChange,
      "period-change": _vm.handlePeriodChange
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ce76d54"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gantt.vue
// module id = 203
// module chunks = 1